// A dynamic route import can fail when this tab still runs an old build whose
// hashed chunks are no longer served, or when the request itself is dropped by
// an overloaded server. Vite surfaces both as `vite:preloadError`; reloading
// picks up the current build. The timestamp guard keeps a chunk that fails for
// any other reason from causing a reload loop.
const RELOAD_GUARD_KEY = 'oneteam_preload_error_reload';
const RELOAD_GUARD_WINDOW = 30 * 1000;

window.addEventListener('vite:preloadError', (event) => {
  try {
    const lastReload = Number(window.sessionStorage.getItem(RELOAD_GUARD_KEY)) || 0;
    if (Date.now() - lastReload < RELOAD_GUARD_WINDOW) return;
    window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  } catch (err) {
    // Without sessionStorage the guard can't persist across reloads, so a
    // reload here could loop; let the error surface instead.
    return;
  }

  event.preventDefault();
  window.location.reload();
});
